import { Component, inject, LOCALE_ID, OnInit, signal, computed } from '@angular/core';
import { CommonModule, Location } from '@angular/common';
import { Router } from '@angular/router';
import { ProductInfoStep } from './steps/product-info-step/product-info-step';
import { AttributesStep } from './steps/attributes-step/attributes-step';
import { SubProductsStep } from './steps/sub-products-step/sub-products-step';
import { SuccessfulNotification } from '../../../utils/successful-notification/successful-notification';
import { Loading } from '../../../utils/loading/loading';
import { ScopeService } from '../../../services/scope/scope-service';
import { SCOPES } from '../../../services/scope/scope-constants';
import { ProductAttributeItemResponse } from '../../../services/productAttributes/productAttributes.model';
import { Attribute } from '../../../pages/admin-dashboard/products/add-sub-product/sub-products.model';
import { Error } from '../../public-user-component/auth/shared/error/error';

@Component({
  selector: 'app-add-product-component',
  standalone: true,
  imports: [CommonModule, ProductInfoStep, AttributesStep, SubProductsStep, SuccessfulNotification, Loading, Error],
  templateUrl: './add-product-component.html',
    styleUrl: './add-product-component.scss',
})
export class AddProductComponent implements OnInit {
  private router = inject(Router);
  private scopeService = inject(ScopeService);
  private localeId = inject(LOCALE_ID);
  protected location = inject(Location);

  activeStep        = signal<1 | 2 | 3>(1);
  createdProductId  = signal<number | null>(null);
  hasSubProducts    = signal(false);
  productAttributes = signal<ProductAttributeItemResponse[]>([]);
  productTitleEn    = signal<string>('');
  productTitleAr    = signal<string>('');

  pageLoading  = signal(true);
  pageError    = signal<string | null>(null);
  accessDenied = signal(false);
  showSuccess  = signal(false);

  mappedAttributes = computed<Attribute[]>(() =>
    this.productAttributes().map(attr => ({
      attributeKey: {
        id: attr.attributeKey.id,
        titleEn: attr.attributeKey.titleEn,
        titleAr: attr.attributeKey.titleAr,
      },
      attributeValues: attr.attributeValues.map(v => ({
        id: v.id ?? 0,
        titleEn: v.titleEn,
        titleAr: v.titleAr,
      })),
    }))
  );

  ngOnInit() {
    this.checkAccess();
  }

  private checkAccess() {
    const hasScope = this.scopeService.hasScope(SCOPES.PRODUCTS?.CREATE);
    if (!hasScope) {
      this.accessDenied.set(true);
      this.pageLoading.set(false);
      return;
    }
    this.pageLoading.set(false);
  }

  onStepOneComplete(event: { id: number; hasSub: boolean; titleEn: string; titleAr: string }) {
    this.createdProductId.set(event.id);
    this.productTitleEn.set(event.titleEn);
    this.productTitleAr.set(event.titleAr);
    if (event.hasSub) {
      this.activeStep.set(2);
    } else {
      this.showSuccess.set(true);
      setTimeout(() => {
        this.router.navigate(['/admin/products/view-product', event.id]);
      }, 1500);
    }
  }

  onStepTwoComplete(event: ProductAttributeItemResponse[]) {
    this.productAttributes.set(event);
    this.activeStep.set(3);
  }

  onStepThreeComplete() {
  this.showSuccess.set(true);
  setTimeout(() => {
    this.router.navigate(['/admin/products/view-product', this.createdProductId()]);
  }, 2000);
}
  isArabic(): boolean {
    return this.localeId.startsWith('ar');
  }
}